import e, { useEffect as x, useState as f, useCallback as V } from "react";
import T from "./index182.mjs";
import $ from "./index174.mjs";
import a from "./index183.mjs";
import k from "./index184.mjs";
import { Button as F } from "./index82.mjs";
import { atom as K, useAtomValue as m, useSetAtom as _ } from "jotai";
import v from "classnames";
const D = 10, M = ({
  id: t,
  name: l,
  value: c,
  onChange: o,
  iconBlock: n,
  placeholder: i,
  state: d = "default",
  hint: r,
  disabled: s = !1
}) => {
  const p = d === "error";
  return /* @__PURE__ */ e.createElement("div", { className: a.custom_text_field }, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: v(a.input_container, {
        [a.input_error]: p,
        [a.input_disabled]: s
      })
    },
    n ? /* @__PURE__ */ e.createElement("div", { className: a.icon }, n) : null,
    /* @__PURE__ */ e.createElement(
      "input",
      {
        id: t,
        name: l,
        type: "text",
        value: c,
        onChange: (u) => o(u.target.value),
        placeholder: i,
        disabled: s,
        className: a.input,
        "data-testid": "text",
        style: n ? void 0 : { paddingLeft: "12px" }
      }
    )
  ), r ? /* @__PURE__ */ e.createElement(
    "div",
    {
      className: v(a.hint, {
        [a.error]: p
      })
    },
    r
  ) : null);
}, b = K(""), I = ({
  validate: t,
  codeAtom: l,
  customClasses: c,
  children: o
}) => {
  const n = m(l);
  return /* @__PURE__ */ e.createElement(
    "form",
    {
      onSubmit: (i) => {
        i.preventDefault(), t == null || t();
      },
      className: v(a.field, c),
      "data-testid": "code-expanded"
    },
    /* @__PURE__ */ e.createElement("div", { className: a.code_field }, o),
    /* @__PURE__ */ e.createElement("div", { className: a.apply_button }, /* @__PURE__ */ e.createElement(
      F,
      {
        type: "submit",
        label: I18n.t("booking_engine.global.apply"),
        dataTestId: "button-apply-code",
        disabled: !!n
      }
    ))
  );
}, g = ({ children: t }) => /* @__PURE__ */ e.createElement("div", { className: a.hint, "data-testid": "code-hint" }, t), w = ({
  codeAtom: t,
  validateCode: l,
  showHint: c,
  customClasses: o,
  icon: n
}) => {
  const i = m(t), d = _(t), r = m(b), [s, p] = f(i), [u, y] = f(
    "default"
    /* DEFAULT */
  ), [N, C] = f(0), S = V(async () => {
    if (N >= D)
      return y(
        "too_many_attempts"
        /* TOO_MANY_ATTEMPTS */
      );
    await l(s) ? d(s) : (C((h) => h + 1), y(
      "invalid"
      /* INVALID */
    ));
  }, [s, N, d, l]), E = u === "invalid" || u === "too_many_attempts";
  return /* @__PURE__ */ e.createElement(
    I,
    {
      validate: S,
      codeAtom: t,
      customClasses: o
    },
    /* @__PURE__ */ e.createElement(
      M,
      {
        id: "promo_code",
        name: "promo_code",
        value: s,
        onChange: p,
        iconBlock: n || /* @__PURE__ */ e.createElement(k, null),
        placeholder: I18n.t(`${r}.placeholder`),
        state: E ? "error" : "default",
        hint: E ? I18n.t(`${r}.${u}`) : void 0
      }
    ),
    c && !E ? /* @__PURE__ */ e.createElement(g, null, I18n.t(`${r}.hint`)) : null
  );
}, B = ({
  codeAtom: t,
  customClasses: l
}) => {
  const c = m(t), o = _(t), n = m(b);
  return /* @__PURE__ */ e.createElement(I, { codeAtom: t, customClasses: l }, /* @__PURE__ */ e.createElement("div", { className: a.valid, "data-testid": "code-valid" }, /* @__PURE__ */ e.createElement("div", { className: a.valid_icon }, /* @__PURE__ */ e.createElement($, { className: a.valid_icon })), /* @__PURE__ */ e.createElement("span", null, c), /* @__PURE__ */ e.createElement(
    "button",
    {
      className: a.delete,
      onClick: () => o(""),
      "data-testid": "code-delete",
      "aria-label": I18n.t(`${n}.delete`),
      type: "button"
    },
    /* @__PURE__ */ e.createElement(T, null)
  )), /* @__PURE__ */ e.createElement(g, null, I18n.t(`${n}.valid`)));
}, A = ({
  codeAtom: t,
  validateCode: l,
  showHint: c,
  translationKey: o = "booking_engine.information.promo_code",
  customClasses: n,
  icon: i,
  iconBlock: d
}) => {
  const r = m(t), s = _(b);
  return x(() => {
    s(o);
  }, [o, s]), r ? /* @__PURE__ */ e.createElement(B, { codeAtom: t, customClasses: n }) : /* @__PURE__ */ e.createElement(
    w,
    {
      codeAtom: t,
      customClasses: n,
      validateCode: l,
      showHint: c,
      icon: i || d
    }
  );
};
export {
  A as ValidateCode
};
